import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Alert, AlertType, Icon, ColorText, Dialog } from './snack-bar.model';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class SnackBarService {
    
    private subject = new Subject<Alert>();
    private subjectDiag = new Subject<Dialog>();

    constructor(private router: Router) {
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.clear();
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    getDiag(): Observable<any> {
        return this.subjectDiag.asObservable();
    }

    success(message: any) {
        this.alert(AlertType.success, message, Icon.success);
    }

    error(message: any) {
        this.alert(AlertType.error, message, Icon.error);
    }

    info(message: any) {
        this.alert(AlertType.info, message, Icon.info);
    }

    warn(message: any) {
        this.alert(AlertType.warning, message, Icon.warning);
    }

    confirm(message: any, event: Function, msgSi: string, msgNo: string) {
        this.dialog(AlertType.confirm, message, event, msgSi, msgNo);
    }

    alert(type: AlertType, message: any, icon: Icon) {
        let messages: Array<string> = [];

        if (message instanceof Array)
            messages = message;
        else
            messages.push(message);

        this.subject.next(<Alert>{ type: type, messages: messages, icon: icon });

        if (type == AlertType.success || type == AlertType.info) {
            setTimeout(() => {
                this.clear();
            }, 3000);
        }
    }

    clear() {
        this.subject.next();
    }

    /** Confirm */
    dialog(type: AlertType, message: string, event: Function, msgSi: string, msgNo: string, colorText: ColorText = ColorText.green) {
        this.subjectDiag.next(<Dialog>{ type: type, message: message, event: event, msgSi: msgSi, msgNo: msgNo, colorText });
    }
}